import Enum from '/@/modules/core/app/helpers/Enum';
import Lang from '/@/modules/core/app/services/Lang';
import EstateTypeLang from '/@/modules/estate/services/EstateTypeLang';

export class ClearVaultContactRelationshipType extends Enum {
  key!: string | null;
  value!: string;
  displayValue!: string;

  static BIOLOGICAL: ClearVaultContactRelationshipType = {
    key: 'biological',
    get value(): string {
      return Lang.t('contact.biological-estatename-child', {
        estateName: EstateTypeLang.estate?.contact.fullName ?? 'the planner'
      });
    },
    get displayValue(): string {
      return Lang.t('contact.biological-child');
    }
  };

  static ADOPTED: ClearVaultContactRelationshipType = {
    key: 'adopted',
    get value(): string {
      return Lang.t('contact.legally-estatename-child', {
        estateName: EstateTypeLang.estate?.contact.fullName ?? 'the planner'
      });
    },
    get displayValue(): string {
      return Lang.t('contact.legally-adopted-child');
    }
  };

  static OTHER: ClearVaultContactRelationshipType = {
    key: null,
    get value(): string {
      return Lang.t('contact.other-explain');
    },
    get displayValue(): string {
      return Lang.t('contact.other');
    }
  };
}
